'use client';

import Link from 'next/link';
import Image from 'next/image';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import parse from 'html-react-parser';
import clsx from 'clsx';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { BLOG_ROUTING_BASE } from 'config';
import { addCanalPlusGTMClass, prepareImagePath } from 'services/lib/util';
import { Categories } from '../../categories/categories';
import { PublicationDate } from '../../publication-date/publication-date';
import { RectangleArrow } from '../../icons/rectangle-arrow';

const ACFHeroSlider = ({ data }) => {
  const slides = data?.heroSlider?.slider?.nodes;

  if (!slides || !Array.isArray(slides)) {
    return null;
  }

  return (
    <div className="heroSlider px-0" style={{ width: '100%' }}>
      <div id="previousButton" className="swiper-button-prev px-0">
        <RectangleArrow />
      </div>
      <div id="nextButton" className="swiper-button-next px-0">
        <RectangleArrow />
      </div>

      <Swiper
        navigation={{
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next',
        }}
        modules={[Navigation]}
        spaceBetween={16}
        slidesPerView={'auto'}
        centeredSlides
        loop
        slideToClickedSlide={true}
        className="px-0"
      >
        {slides.map((slide, i) => {
          return (
            <SwiperSlide className="item px-0" key={slide.sourceUrl || i}>
              <div className="galleryItem px-0">
                <Link href={`${BLOG_ROUTING_BASE}${slide.uri}`} className="customLink px-0">
                  <div className="galleryImage px-0">
                    {slide.featuredImage?.node && (
                      <Image
                        className="imageWrapper"
                        src={prepareImagePath(slide.featuredImage.node.sourceUrl)}
                        alt={slide.featuredImage.node.title || slide.title}
                        fill
                        priority={i === 0}
                        fetchPriority={i === 0 ? 'high' : 'auto'}
                      />
                    )}
                  </div>
                </Link>

                <div className="slideContent px-0">
                  <p className="imageTitle px-0">
                    <Link
                      href={`${BLOG_ROUTING_BASE}${slide.uri}`}
                      className={clsx(addCanalPlusGTMClass(slide.uri), 'px-0')}
                    >
                      {slide.title}
                    </Link>
                  </p>

                  <div className="slideDate px-0" style={{ display: 'flex', alignItems: 'center' }}>
                    <PublicationDate date={slide.date} />
                    {slide.categories && <Categories categories={slide.categories} />}
                  </div>

                  <div className="slideDescription text-secondary px-0">
                    {slide.excerpt ? parse(slide.excerpt) : null}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default ACFHeroSlider;
